if (window.__webpack_nonce__ !== undefined) {
    __webpack_nonce__ = window.__webpack_nonce__;
}